/**
 * @fileoverview Type definitions for facility-related data models.
 */

import {AddressModel, StateModel} from "./address";
import {OrganizationModel} from "./organization";

/**
 * Type definition for facility data model.
 */
export enum FacilityStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DELETED = "DELETED",
}
export enum FacilityFeatureFlagsEnum {
  PCC_BASIC = "PCC_BASIC",
  PCC_PREMIUM = "PCC_PREMIUM",
  PCC_SYNC = "PCC_SYNC",
  PCC_PATIENT_CONTACTS_SYNC = "PCC_PATIENT_CONTACTS_SYNC",
  ARBITRATION_EMAIL = "ARBITRATION_EMAIL",
  MARQUIS_COVID_EMAIL = "MARQUIS_COVID_EMAIL",
  ORG_ADMIN_ONLY_DELETE_ADMISSIONS = "ORG_ADMIN_ONLY_DELETE_ADMISSIONS",
  FACILITY_ADMIN_ONLY_DELETE_ADMISSIONS = "FACILITY_ADMIN_ONLY_DELETE_ADMISSIONS",
}

export interface FacilityFeatureFlagsModel {
  readonly featureFlags?: ReadonlyArray<FacilityFeatureFlagsEnum>;
  readonly id?: string;
  readonly name?: string;
}

export interface FacilityFeatureFlagsRootModel {
  readonly facilities?: ReadonlyArray<FacilityFeatureFlagsModel>;
  readonly organizationId?: string;
  readonly organizationName?: string;
}

export type CreateFacilityModel = {
  address: AddressModel<StateModel>;
  description?: string;
  email?: string;
  id?: string;
  name: string;
  organizationId: string;
  pccFacilityId?: number;
  pccOrganizationId?: string;
  phone?: string;
  templateName: string;
  timeZoneId: string;
};

export type SimpleFacilityModel = {
  id: string;
  name: string;
  code: string;
  organization: OrganizationModel;
  email?: string;
  phone?: string;
  timeZoneId: string;
  templateName?: string;
  featureFlags?: Record<string, boolean>;
  pccIntegrationStatus?: string;
  pccUploadActive?: boolean;
  availableWorkflows?: ReadonlyArray<string>;
};

export type FacilityModel = {
  id: string;
  name: string;
  code: string;
  organization: OrganizationModel;
  address: AddressModel<StateModel>;
  phone?: string;
  email?: string;
  status: FacilityStatusEnum;
  timeZoneId: string;
  templateName?: string;
  featureFlags?: Record<string, boolean>;
  goLiveDate?: Date | null;
};
/**
 * Type definition for updating facility template.
 */
export type UpdateFacilityTemplateModel = {
  templateName: string;
  migrateAdmissions: boolean;
};

/**
 * Type definition for PointClickCare facility mapping.
 */
export type PccFacilityMappingModel = {
  defaultDocumentCategoryIdentifier?: number;
  pccFacilityId?: number | string;
  pccOrganizationId?: string;
  arbitrationCategoryId?: number | null;
  workflowCategoryMappings?: Record<string, number | null>;
};
